// @flow
import React, {useState} from "react";
import {Redirect} from "react-router-dom";
import PropTypes from "prop-types";

const SearchButtonList = ({activeChoice}) => {

    const [redirectTo, setRedirectTo] = useState();
    
    if(redirectTo) {
        return (
            <Redirect push to={redirectTo}/>
        );
    }
    
    function showClickableOrReadonly(label, destination) {
        if(activeChoice && label===activeChoice) {
            return (
                <button className="li-button li-bg-primary-active li-fg-white mr-2 mr-md-2" disabled><i className="fa fa-search mr-2"/>{label}</button>
            );
        }
        return(
            <button className="li-button li-primary li-pointer mr-2 mr-md-2"
                    onClick={() => setRedirectTo(destination)}><i className="fa fa-search mr-2"/>{label}</button>
        );
    }
    
    return(
        <div className="row my-2">
            <div className="col justify-content-between">
                <div className="d-sm-inline-block my-2">
                    {showClickableOrReadonly("cases","/case_search")}
                    {showClickableOrReadonly("samples","/sample_search")}
                </div>
                <div className="d-sm-inline-block">
                    {showClickableOrReadonly("magazines","/mag_search")}
                    {showClickableOrReadonly("barcodes","/barcode_search")}
                </div>
            </div>
        </div>
    );
}

SearchButtonList.propTypes = {
    activeChoice: PropTypes.string,
}

export default SearchButtonList;